import { render, staticRenderFns } from "./StatusFooter.vue?vue&type=template&id=6f1ab5d5&scoped=true&"
import script from "./StatusFooter.vue?vue&type=script&lang=js&"
export * from "./StatusFooter.vue?vue&type=script&lang=js&"
import style0 from "./StatusFooter.vue?vue&type=style&index=0&id=6f1ab5d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ab5d5",
  null
  
)

export default component.exports